package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.DigicodeRepository

/**
 * Use case for cancelling a digicode challenge (GM action).
 */
class CancelDigicodeUseCase(
    private val digicodeRepository: DigicodeRepository
) {
    suspend operator fun invoke(
        digicodeId: String
    ): Result<Unit> {
        return digicodeRepository.cancel(
            digicodeId = digicodeId
        )
    }
}
